import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, ResponseContentType } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable } from '@angular/core';
import { ErrorsService } from './tools/errors.service';

@Injectable()
export class AvalesService {

  private service_url: string;

  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.service_url = this.constantsService.apiURL + '/avales';
  }

  public get(idCreditos: number) {
    let serviceUrl = this.service_url + '?idCreditos='+ idCreditos;

    return this.http.get(serviceUrl , this.authService.getAuthHeaders());
  }

  public save( avaluo: object) {
    return this.http.post(this.service_url , avaluo, this.authService.getAuthHeaders());
  }

  public update( avaluo: object) {
    return this.http.put(this.service_url , avaluo, this.authService.getAuthHeaders());
  }

  public delete(idAval: number) {
    const service = this.service_url + '/' + idAval;
    return this.http.delete(service , this.authService.getAuthHeaders());
  }

  public validate(data: any){
    let error = [];
    
    if(!this.validatorService.required(data.nombre)){
      error["nombre"] = this.errorService.required;
    }    
    
    if(!this.validatorService.required(data.domcilio)){
      error["domcilio"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.telefono)){
        error["telefono"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.elector)){
        error["elector"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.curp)){
        error["curp"] = this.errorService.required;
    }

    if(!this.validatorService.required(data.poblacion)){
      error["poblacion"] = this.errorService.required;
  }

    return error;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/avales.service.ts